import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { LEGAL_PROJECTS, DOC_KEYS } from '../data/legalDocs';
import { useLanguage } from '../i18n/LanguageContext';

const LegalHub = () => {
  const { t } = useLanguage();

  return (
    <>
      <Helmet>
        <title>{t.legal.hubTitle} — Havel br</title>
        <meta name="description" content={t.legal.hubIntro} />
      </Helmet>

      <div className="container">
        <div className="legal-content web-content">
          <h1>{t.legal.hubTitle}</h1>
          <p>{t.legal.hubIntro}</p>

          <div className="legal-hub">
            {LEGAL_PROJECTS.map((project) => (
              <div className="legal-hub-card" key={project.slug}>
                <div className="legal-hub-head">
                  <span className="legal-hub-emoji">{project.emoji}</span>
                  <div>
                    <h2>{project.name}</h2>
                    <p>{t.legal.projects[project.slug]}</p>
                  </div>
                </div>
                <ul className="legal-hub-links">
                  {DOC_KEYS.map((doc) => (
                    <li key={doc}>
                      <Link to={`/legal/${project.slug}/${doc}`}>{t.legal.docTypes[doc]}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LegalHub;
